import {Fragment} from "react";
import {theme} from "Theme";
import {usePermitTypesWithColors} from "permit/hooks";
import {DateUtil} from "base/format/utilities";
import {Tag} from "base/shared/components";
import Stack from "@mui/material/Stack";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Divider from "@mui/material/Divider";

const PermitTypeAndDatesTags = ({item, short = false, ...props}) => {
    const types = item?.types;
    const {filteredTypesWithColors} = usePermitTypesWithColors(types);

    const getLabel = label => (short ? label.charAt(0) : label);

    return (
        <Stack {...props}>
            {filteredTypesWithColors?.map((type, index) => {
                const startField = `${type.value}_start_date`;
                const endField = `${type.value}_end_date`;

                const startDate = item[startField];
                const endDate = item[endField];
                const datesText =
                    startDate && endDate
                        ? `${DateUtil.formatDateShort(
                              startDate
                          )} – ${DateUtil.formatDateShort(endDate)}`
                        : "";

                return (
                    <Fragment key={index}>
                        {index > 0 && (
                            <Divider
                                sx={{
                                    borderColor: theme.palette.divider,
                                    borderBottomWidth: "1px",
                                }}
                            />
                        )}
                        <Box
                            sx={{
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "space-between",
                                pt: 0.5,
                                pb: 0.1,
                            }}
                        >
                            <Tag
                                color={type.color}
                                textColor={type.contrastTextColor}
                                style={{
                                    textAlign: "left",
                                    ...(short
                                        ? {
                                              borderRadius: "50%",
                                              border: "solid 1px white",
                                              px: "8px",
                                          }
                                        : null),
                                }}
                            >
                                {getLabel(type.label)}
                            </Tag>
                            {!short && datesText && (
                                <Typography variant="body2" sx={{ml: 1}}>
                                    {datesText}
                                </Typography>
                            )}
                        </Box>
                    </Fragment>
                );
            })}
        </Stack>
    );
};

export default PermitTypeAndDatesTags;
